module.exports = __webpack_public_path__ + "static/media/terminos.4e20e512.pdf";